import { getConfig, klinikenApi } from "@/api";
import { StructuredAvdelning } from "@/tabs/Vardplatsbokning/types";
import { flashWarning } from "@/utils";

/**
 * Komplicerad funktion som hämtar avdelningar och sängar, manglar datan och spottar ut avdelningar som innehåller
 * rum och rum som innehåller sängar
 */
export const fetchStructuredAvdelningar: () => Promise<StructuredAvdelning[]> = async () => {
    try {
        const { data: sangarData } = await klinikenApi.get("/slutenvard/sangar/", getConfig({}));
        const { data: unitsData } = await klinikenApi.get(
            "/core/orgunits/",
            getConfig({
                params: {
                    vardenhetstyp: "slutenvardsavdelning",
                },
            })
        );

        /*
            Grupperar sängar på avdelningsid. Sen grupperar vi sängarna inom varje avdelning på salar
         */
        const sangarByAvdelning = Object.entries(
            // @ts-ignore
            Object.groupBy(sangarData.results, ({ sal }) => sal.vardavdelning.id)
        ).map(([avdelningId, sangar]) => [
            avdelningId,
            // @ts-ignore
            Object.groupBy(sangar, ({ sal }) => sal.id),
        ]);

        const extractedAvdelningar = sangarByAvdelning.map(([avdelningId, salar]) => {
            return {
                /*
                    salar är object med key salId och value sang. Vi måste gräva oss ner för att hämta informationen
                    vi vill ha. [0] är en array med sängar inom en salgrupperingen. [0][0] är en säng.
                    Resultatet är:
                    {
                     avdelningsdata
                     salar: {
                        salsdata,
                        sangar: {
                            sangdata
                        }[],
                     }[]
                    }

                    Se TS för return i fetchStructuredAvdelningar
                 */
                // @ts-ignore
                ...Object.values(salar)[0][0].sal.vardavdelning,
                salar: [
                    ...new Map(
                        // @ts-ignore
                        Object.entries(salar).map(([salId, sangar]) => {
                            // @ts-ignore
                            const { vardavdelning, ...cleanSal } = sangar[0].sal;
                            // @ts-ignore
                            const cleanSangar = sangar.map((sang) => {
                                const { sal, ...cleanSang } = sang;

                                return cleanSang;
                            });

                            return [salId, { ...cleanSal, sangar: cleanSangar }];
                        })
                    ).values(),
                ],
            };
        });

        return extractedAvdelningar;
    } catch (error) {
        console.error(error);

        flashWarning("Kunde inte hämta operationssalar");

        return [];
    }
};
